exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.upsell-popup-bg-wrapper[data-v-272aab7e]{\n  display:block;\n  position:fixed;\n  top:0;\n  left:0;\n  width:100%;\n  height:100%;\n  background-color:rgba(0, 0, 0, 0.5);\n  z-index:9999;\n  overflow-y:auto;\n}\n.upsell-popup-bg-container[data-v-272aab7e]{\n  position:absolute;\n  width:100%;\n  max-width:800px;\n  padding:50px;\n  left:50%;\n  transform:translateX(-50%);\n}\n.upsell-popup-bg-content[data-v-272aab7e]{\n  position:relative;\n  display:flex;\n  justify-content:center;\n  margin-bottom:20px;\n}", ""]);

// exports
